function customMinActivationTimeWindow() {
  const { input } = this.validator;
  const { evaluationPeriod, activate, enabled } = input;

  if (!enabled || !evaluationPeriod) {
    return true;
  }

  // The activation times per window must be greater than or equal to the evaluationPeriod (aka Policy Window)
  const { times, timeWindow, timeUnit } = activate;
  const activateTime = timeUnit === 'minute' ? timeWindow * 60 : timeWindow * 3600; // convert activate to seconds
  const timesPerWindow = activateTime / times;

  return timesPerWindow >= evaluationPeriod;
}

export default {
  message: "The threshold's Activation Frequency cannot be more frequent than the policy's Evaluation Frequency",
  fn: customMinActivationTimeWindow
};
